const SENSITIVE_ROUTE_SEGMENT =
  /(?:@|%40|eyJ[a-zA-Z0-9_-]{8,}\.|[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|^\+?\d{7,}$)/i;

function maskUnexpectedSensitiveSegments(pathname: string): string {
  return pathname
    .split("/")
    .map((segment) =>
      segment.length > 64 || SENSITIVE_ROUTE_SEGMENT.test(segment) ? ":value" : segment,
    )
    .join("/");
}

export function normalizeAnalyticsRoute(pathname: string): string {
  if (pathname.startsWith("/app/reader/")) return "/app/reader/:payload";
  if (pathname.startsWith("/auth/verify-link/")) return "/auth/verify-link/:token";
  if (pathname.startsWith("/v/")) return "/v/:token";
  if (pathname.startsWith("/r/")) return "/r/:referralCode";
  return maskUnexpectedSensitiveSegments(pathname || "/");
}
